import clsx from 'clsx'
import type { JSX, ReactNode } from 'react'
import { H3, P, Stack } from '~/components-v2'

type CompareCardProps = {
  icon: JSX.Element
  title: string
  subhead: string | ReactNode
  children?: JSX.Element | JSX.Element[]
  className?: string
}

export const ComparisonCard = ({
  icon,
  title,
  subhead,
  children,
  className,
}: CompareCardProps) => {
  return (
    <div className={clsx('compare-card', className)}>
      <Stack row gap={10} className="compare-card-header">
        <div className="compare-icon">{icon}</div>
        <Stack as="hgroup" gap={4} shrink={1}>
          <H3 fontSize="xxl">{title}</H3>
          <P color="text2" fontSize="lg">
            {subhead}
          </P>
        </Stack>
      </Stack>
      <div className="compare-content">{children}</div>
    </div>
  )
}
